/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Create, Edit, SimpleForm, useTranslate } from 'react-admin';
import UnitForm from './UnitForm';
import courseStatus from '../../enums/course-status.enum';
import customEdit from './edit';
import customCreate from './create';

const UnitDetail = (props) => {
  const { actionType, basePath } = props;
  const translate = useTranslate();
  const statusLabel = translate('custom.general.status');
  const nameLabel = translate('custom.general.name');
  const courseLabel = translate('custom.courses.title');
  const scormLabel = translate('custom.scorms.titleSingular');
  const resourceText = translate('custom.units.resource');
  const updatedText = translate('custom.units.updated');
  const createdText = translate('custom.units.created');
  const edit = useCallback(
    customEdit({
      basePath,
      resourceText,
      updatedText,
    })
  );
  const create = useCallback(
    customCreate({
      basePath,
      resourceText,
      createdText,
    })
  );
  return (
    <>
      {actionType === 'edit' ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Edit {...props}>
          <SimpleForm save={edit}>
            <UnitForm
              status={courseStatus}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              courseLabel={courseLabel}
              scormLabel={scormLabel}
            />
          </SimpleForm>
        </Edit>
      ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Create {...props}>
          <SimpleForm save={create}>
            <UnitForm
              status={courseStatus}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              courseLabel={courseLabel}
              scormLabel={scormLabel}
            />
          </SimpleForm>
        </Create>
      )}
    </>
  );
};

UnitDetail.propTypes = {
  actionType: PropTypes.string,
  basePath: PropTypes.string.isRequired,
};

UnitDetail.defaultProps = {
  actionType: 'create',
};

export default UnitDetail;
